import { types } from 'mobx-state-tree';
import { RowModel } from '../rowModel';

export const MapUrlSettingsModel = types
  .model('MapUrlSettingsModel', {
    mapUrl: types.maybe(types.string)
  })
  .volatile(() => ({
    hasChanges: false
  }))
  .actions(self => ({
    setHasChanges(hasChanges) {
      self.hasChanges = hasChanges;
    },
    update({ mapUrl }) {
      self.mapUrl = mapUrl;
    }
  }));

export const MapUrlSettingsStore = types.compose(RowModel, MapUrlSettingsModel).named('MapUrlSettingsStore');
